import React from "react";
import { useTranslation } from "react-i18next";
import { useSelectDocumentsContext } from "../../context";
import styles from "./styles.scss";
import { Props } from "./types";
import classNames from "classnames";

function SelectionSummary(_: Props) {
  const { t } = useTranslation();
  const { selection, resetSelection } = useSelectDocumentsContext();

  return (
    <span
      className={classNames(styles.selectionSummary, {
        [styles.selectionSummaryEmpty]: selection.length === 0,
      })}
    >
      {selection.length}{" "}
      {t(`selectDocuments.selectedDocument${selection.length > 1 ? "s" : ""}`)}
      {selection.length > 0 && (
        <button className={styles.button} onClick={() => resetSelection()}>
          {t("selectDocuments.resetSelection")}
        </button>
      )}
    </span>
  );
}

export { SelectionSummary };
